import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { LeafletModule } from "@asymmetrik/ngx-leaflet";
import { ReactiveComponentModule } from "@ngrx/component";
import { CalendarModule, DateAdapter } from "angular-calendar";
import { adapterFactory } from "angular-calendar/date-adapters/date-fns";
import { AccordionModule } from "ngx-bootstrap/accordion";
import { BsDropdownModule } from "ngx-bootstrap/dropdown";
import { BsDatepickerModule } from "ngx-bootstrap/datepicker";
import { NgPipesModule } from "ngx-pipes";
import { PageNotFoundComponent } from "./components/";
import { AssistanceEditorComponent } from "./components/assistance-editor/assistance-editor.component";
import { AssistanceViewComponent } from "./components/assistance-view/assistance-view.component";
import { ConfirmModalComponent } from "./components/confirm-modal/confirm-modal.component";
import { ProximityModalComponent } from "./components/proximity-modal/proximity-modal.component";
import { RecordDetailModalComponent } from "./components/record-detail-modal/record-detail-modal.component";
import { ErrorModalComponent } from "./components/error-modal/error-modal.component";
import { ErrorPanelComponent } from "./components/error-panel/error-panel.component";
import { FesBaseComponent } from "./components/fes-base.component";
import { FilterFieldConfigComponent } from "./components/filter-field-config/filter-field-config.component";
import { PointQrCodeComponent } from './components/point-qr-code/point-qr-code.component';
import { SortFieldComponent } from "./components/sort-field/sort-field.component";
import { TableViewActionPickerComponent } from "./components/table-view/table-view-action-picker.component";
import { TableViewCalendarComponent } from "./components/table-view/table-view-calendar/table-view-calendar.component";
import { DefaultCellRendererComponent } from "./components/table-view/table-view-component-base";
import { TableViewConfigComponent } from "./components/table-view/table-view-config/table-view-config.component";
import { TableViewFilterInputComponent, TableViewFilterInputDropdownComponent } from "./components/table-view/table-view-filter-input.component";
import { UtcClockComponent } from "./components/utc-clock-component";
import { ClickDoubleDirective } from './directives/click-double.directive';
import { FilterFieldDirective } from "./directives/filter-field.directive";
import { FilterDetailModalComponent } from "./components/filter-detail-modal/filter-detail-modal.component";
import { LetDirective } from "./directives/let-directive";
import { ListViewDirectiveOf } from "./directives/list-view.directive";
import { HighlightDirective } from "./directives/highlight.directive";
import { MapImageOverlayComponent } from "./mapping/map-image-overlay/map-image-overlay.component";
import { MapPointSummaryComponent } from "./mapping/map-point-summary/map-point-summary.component";
import { PathPlotterComponent } from "./mapping/path-plotter/path-plotter.component";

import { NgxQRCodeModule } from "@techiediaries/ngx-qrcode";
import { ReplacePipe } from "./pipes/replace.pipe";
import { ToNumberPipe } from "./pipes/to-number.pipe";
import { DurationPipe } from "./pipes/duration.pipe";

import {
    IsSuccessTaskStatusPipe,
    TaskStatusBorderedCssPipe,
    TaskStatusCssPipe,
    TaskStatusNamePipe,
} from "./pipes/task-status.pipe";
import { BarometerComponent } from './components/barometer/barometer.component';
import { WeatherQueryComponent } from './components/weather-query/weather-query.component';
import { KmlViewerComponent } from './mapping/kml/kml-viewer/kml-viewer.component';
import { TabsModule } from "ngx-bootstrap/tabs";
import { DragDropModule } from "@angular/cdk/drag-drop";
import { StatsViewComponent } from './components/stats-view/stats-view.component';
import { DeviceDetailModalComponent } from './components/device-detail-modal/device-detail-modal.component';

@NgModule({
    declarations: [
        PointQrCodeComponent,
        FesBaseComponent,
        AssistanceEditorComponent,
        AssistanceViewComponent,
        PageNotFoundComponent,
        ListViewDirectiveOf,
        SortFieldComponent,
        FilterFieldDirective,
        ConfirmModalComponent,
        ProximityModalComponent,
        RecordDetailModalComponent,
        TaskStatusNamePipe,
        TaskStatusCssPipe,
        IsSuccessTaskStatusPipe,
        TaskStatusBorderedCssPipe,
        DefaultCellRendererComponent,
        UtcClockComponent,
        LetDirective,
        MapImageOverlayComponent,
        PathPlotterComponent,
        MapPointSummaryComponent,
        ErrorPanelComponent,
        ErrorModalComponent,
        TableViewActionPickerComponent,
        DeviceDetailModalComponent,
        FilterFieldConfigComponent,
        FilterDetailModalComponent,
        TableViewConfigComponent,
        TableViewFilterInputComponent,
        TableViewFilterInputDropdownComponent,
        TableViewCalendarComponent,
        ReplacePipe,
        ToNumberPipe,
        DurationPipe,
        ClickDoubleDirective,
        HighlightDirective,
        BarometerComponent,
        WeatherQueryComponent,
        KmlViewerComponent,
        StatsViewComponent
    ],
    imports: [
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        LeafletModule,
        ReactiveComponentModule,
        NgPipesModule,
        BsDropdownModule.forRoot(),
        BsDatepickerModule.forRoot(),
        AccordionModule.forRoot(),
        TabsModule.forRoot(),
        CalendarModule.forRoot({
            provide: DateAdapter,
            useFactory: adapterFactory,
        }),
        NgxQRCodeModule,
        DragDropModule
    ],
    exports: [
        PointQrCodeComponent,
        FesBaseComponent,
        AssistanceViewComponent,
        AssistanceEditorComponent,
        ReactiveFormsModule,
        ListViewDirectiveOf,
        SortFieldComponent,
        FilterFieldDirective,
        ConfirmModalComponent,
        RecordDetailModalComponent,
        TaskStatusNamePipe,
        TaskStatusCssPipe,
        IsSuccessTaskStatusPipe,
        TaskStatusBorderedCssPipe,
        DefaultCellRendererComponent,
        UtcClockComponent,
        LetDirective,
        MapPointSummaryComponent,
        ErrorPanelComponent,
        ErrorModalComponent,
        TableViewActionPickerComponent,
        DeviceDetailModalComponent,
        FilterFieldConfigComponent,
        TableViewConfigComponent,
        TableViewFilterInputComponent,
        TableViewFilterInputDropdownComponent,
        TableViewCalendarComponent,
        ReplacePipe,
        ToNumberPipe,
        DurationPipe,
        ClickDoubleDirective,
        HighlightDirective,
        BarometerComponent,
        WeatherQueryComponent,
        KmlViewerComponent,
        StatsViewComponent,
    ],
})
export class SharedModule {}
